









































import { Component, Vue, Prop } from 'vue-property-decorator';
import { solutionListInstance } from '@/model/SolutionListClass';
import { timeFormat } from '@/utils/other';

@Component({
  filters: {
    timeFormat,
  },
})
export default class RequirementSolution extends Vue {
  @Prop({required: true}) private requirement!: IRequirement.IResponse.IRequirementInfo;
  get solutions() {
    return this.requirement ? this.requirement.quotations : [];
  }
  private createSolution() {
    solutionListInstance.createSolution(this.requirement.id);
    this.$router.push({
      name: 'CreateSolution',
    });
  }
  private viewAllSolution() {
    this.$router.push({
      name: 'Solution',
      params: {
        requirementId: this.requirement.id,
      },
    });
  }
  private viewSolution(solutionId: string) {
    this.$router.push({
      name: 'Solution',
      params: {
        id: solutionId,
      },
    });
  }
  private goPaymentPage(quotationId: string) {
    this.$router.push({
      name: 'Payment',
      params: {
        quotationId,
      },
    });
  }
}
